import React, { Component } from 'react';
import './App.css';
import { Appbar, Button, Container } from 'muicss/react';
import Input from 'muicss/lib/react/input';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import {RaisedButton} from 'material-ui';
import firebase from 'firebase';
import Cookies from 'universal-cookie';

export class Top extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div>
        <h2>おしながき</h2>
        <p><a href="/c92">[C92]しまむら</a></p>
        <p><a href="/c93">[C93]Good evening, A5</a></p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/top.js